import { Text } from '@mantine/core';

export const LoadingResults = () => <Text>Results is Loading</Text>;
